@if (isDisplay()) {
  <div @fadeInFadeOut class="inline-block absolute top-56 left-1/2 -translate-x-1/2">
    <app-inline-loader class="w-10 absolute left-1/2 -translate-x-1/2"></app-inline-loader>
    <div class="font-medium text-sm mt-16" [innerHTML]="'common.loading' | translate"></div>
  </div>
}
